import React from 'react';
import { Redirect, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import MembershipStartPage from './Search/MembershipStartPage';
import MembershipHoldPage from './MembershipHoldPage';
import MembershipDetails from './AccountInfo/MembershipDetails';
import { BodyContainerStyled, BodyMedium, ButtonPrimaryLarge, H3 } from '@react/styledComponents';
import useIsCartMultiCurrency from '@hooks/useIsCartMultiCurrency';

const MembershipPages = () => {
    const match = useRouteMatch();
    const history = useHistory();
    const { isCartMultiCurrency } = useIsCartMultiCurrency({ locale: 'US' });

    if (isCartMultiCurrency) {
        return (
            <BodyContainerStyled className="container">
                <div className="gap-8 grid-cols-8 md:grid">
                    <div className="col-span-5">
                        <H3>Purchase a Membership</H3>
                        <BodyMedium className="mt-1rem">
                            You currently have event registrations from a different locale in your cart, and this system
                            does not yet support multi-currency. Please complete checkout or remove those items from
                            your cart, then you may purchase a membership. We apologize for the inconvenience.
                        </BodyMedium>

                        <ButtonPrimaryLarge className="block mt-2rem" onClick={() => history.push('/cart')}>
                            Go To Cart
                        </ButtonPrimaryLarge>
                    </div>
                </div>
            </BodyContainerStyled>
        );
    }

    return (
        <Switch>
            <Route path={`${match.path}/start`} exact>
                <MembershipStartPage />
            </Route>

            <Route path={`${match.path}/hold`}>
                <MembershipHoldPage />
            </Route>

            <Route path={`${match.path}/info`} exact>
                <MembershipDetails isNew={false} />
            </Route>

            <Route path={`${match.path}/info/new`}>
                <MembershipDetails isNew />
            </Route>

            <Route path="*">
                <Redirect to="/membership/start" />
            </Route>
        </Switch>
    );
};

export default MembershipPages;
